import { Static, Optional, Object, String } from '@sinclair/typebox';

import { UnionEnum } from '../../../utils/unionEnum';

import { TravelPassApiError } from './error';
import { AirportCode, ProductCode } from './travel-pass';

export const TravelPassProductQuery = Object({
  origin: AirportCode,
  destination: AirportCode,
  productCode: ProductCode,
  fromDate: Optional(String()),
  toDate: Optional(String()),
  bookingClassCode: Optional(String()),
});
export type TravelPassProductQuery = Static<typeof TravelPassProductQuery>;

export const TravelPassProductError = TravelPassApiError(
  UnionEnum([
    'product-not-found',
    'dates-not-within-product-range',
    'generic-permission-denied',
    'missing-products-query-params',
    'invalid-dates',
  ])
);
export type TravelPassProductError = Static<typeof TravelPassProductError>;

export const TravelPassProductResponse = Object({
  name: String(),
  validFrom: String(),
  validTo: String(),
  productCode: String(),
  punchesLeft: String(),
  punchesTotal: String(),
});
export type TravelPassProductResponse = Static<typeof TravelPassProductResponse>;
